import { Component, ElementRef, HostListener, NgZone, OnInit, Renderer2, ViewChild, ViewEncapsulation, OnDestroy } from '@angular/core';
import * as _ from 'lodash';
import { FormbuilderService } from '../services/formbuilder.service';
import $ from 'jquery';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup } from '@angular/forms';
import { AddNewItemToFormComponent } from './add-new-item/add-new-item-to-form.component';
import { FieldPropertiesComponent } from './field-properties/field-properties.component';
import { TopicItemsComponent } from './topic-items/topic-items.component';
import { CancelConfirmationComponent } from "./cancel-confirmation/cancel-confirmation.component";
import { ActivatedRoute, Router} from '@angular/router'
import { Constants } from '../Constants';
import { FormService } from './form.service';
import { ValidationPopupComponent } from './validation-popup/validation-popup.component';
import { SharedService } from '../services/shared.service';
import { SortTopicsService } from '../sort-topics/sort-topics.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddNewTopicsComponent } from '../add-new-topics/add-new-topics.component';
import { SortformsService } from '../sortforms/sortforms.service';
import { AddNewTopicComponent } from './add-new-topic/add-new-topic.component';
import { diff } from 'deep-object-diff';
import { ElementInfoPopupComponent } from "./element-info-popup/element-info-popup.comoponent";

declare var $: any;
import { ComponentCanDeactivate } from "../services/formerrors.guard";
import { iif, Observable } from 'rxjs';
import { v4 as uuid } from "uuid";

import * as form_limits from '../../assets/form_limits.json';

@Component({
	selector: 'app-form',
	templateUrl: './form.component.html',
	styleUrls: ['./form.component.scss'],
	encapsulation: ViewEncapsulation.None
})

export class FormComponent implements OnInit, OnDestroy, ComponentCanDeactivate {

  // Globals
  formData;
  newFormTemplate;
  formTemplate;
  formGroup: FormGroup;
  constants = Constants;
  element;
  templateId;
  template;
  templateEdit: Boolean = false;
  templateName;
  saveValidityCheck: Boolean = true;
  topics;
  topicsPanel: Boolean = true;
  formName;
  password: string = "";
  isPasswordChanged = false;
  passwordEnabled: Boolean = true;
  passwordHistory: Boolean = true
  topicsList = [];
  elements = [];
  oldTopicsList = [];
  topicIndex;
  settingsTitle: string = "";
  topicSettings: boolean = false;
  topicOptions: any = [];
  isEmbeddable: Boolean = false;
  embeddable_link: string = "";
  embedLink: Boolean = false;
  isDefault: Boolean = false;
  iteration: Boolean = false;
  hashedPasswordExists: Boolean = false;
  lastTopicsIndex = 0;
  dragType = "";
	bgTextColor = "#000000";
  bgColor = "#fff"
  topicTitle: String = "Topics";
  formUpdated: Boolean = false;
  hideButtons: Boolean = false;
  is_archived: Boolean = false;
  is_deleted: Boolean = false;
  hashedPassword = "";
  readTextFieldCheckbox = false;
  readTextFieldValue = "";
  isForTelmplatePreview = false;
  templateVersion: any = "";
  @ViewChild("formbuilder", { static: true }) formBuilder: ElementRef; // Creates element reference to form builder id
  highlightedElementId = undefined;
  openedElemntsMenuId = undefined;
  showFormPreview = false;
  isTemplateChanged = false;
  isFormvalid = true;
  globalError = {};
  passwordsalt = "";
  previewSubscription: any;
  @HostListener('click', ['$event'])
  onClick(event) {
    this.removeHighLightedElement(event)
  }
  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event): void {
    if(this.isTemplateChanged == true && this.isFormvalid == true) {
      this.updateForm("SAVE")
      this.saveValidityCheck = true;
      this.isTemplateChanged = false;
    }
  }
  constructor(
      private _formBuilderService: FormbuilderService,
      private _renderer: Renderer2,
      public dialog: MatDialog,
      private _router: Router,
      private _formService: FormService,
      private activatedRoute: ActivatedRoute,
      private _sharedService: SharedService,
      private _sortTopicsService: SortTopicsService,
      private _snackBar: MatSnackBar,
      private _sortFormService: SortformsService,
      private ngZone: NgZone,
      private addNewItemToFormComponent: AddNewItemToFormComponent
  ) {
    Window["app"] = this;
    document.addEventListener('dragover', function(e) { e.preventDefault() })
    this._sharedService.updateRelatedSubject.subscribe((val) => {
      this.disableUpdateButton()
    })

    this.previewSubscription = this._sharedService.showTemplatePreviewSubject.subscribe((val) => {
      this.previewTemplate()
    })
  }
  removeHighLightedElement(event) {
    // Check if the clicked region not in "page";
    if(this.highlightedElementId && this.highlightedElementId.includes("emptyfield")) {
      return;
    }
    if(event.target && event.target.parentElement.id.includes("menu")) {
      return;
    }
    if(!(document.getElementById('page') && document.getElementById('page').contains(event.target))) {
      if(this.highlightedElementId != undefined) {
        if (document.getElementById(this.highlightedElementId)) {
          document.getElementById(this.highlightedElementId).classList.remove('highlight-element')
        }
        this.highlightedElementId = undefined
      }
      this.closeMenu()
    }
  }

  debouncedOnOptionsChanged: any;
  ngOnInit(): void {
    this.debouncedOnOptionsChanged = _.debounce(
      (eventCopy, index, type, key) => {
        this._onOptionsChanged(eventCopy, index, type, key);
      },
      500,
      { leading: false, trailing: true }
    );
    
    this.oninit();
    document.addEventListener("visibilitychange", this.onTabSwitch, true)
  }

  ngAfterViewInit() {
    let formNameElement = $("#formName");
    if (formNameElement && this.formName && this.formName.length > 0) {
      $("#form-name").attr("data-title", this.formName);
      $("#form-name").attr("data-placeholder", this.formName);
      $("#form-name").attr("value", this.formName);
    }
	}

  ngAfterContentInit() {
    const component = this;
    // Observer for formbuilder node
    const formBuilderNode = document.getElementById('formbuilder');
    const formBuilderConfig = { attributes: true, childList: true, subtree: true };
    const formBuilderCallback = function(mutationsList, observer) {
      if (this.iteration) {
        component.formUpdated = true;
        observer.disconnect();
      }
      this.iteration = true;
    };
    const formBuilderObserver = new MutationObserver(formBuilderCallback);
    formBuilderObserver.observe(formBuilderNode, formBuilderConfig);
  }

  ngOnDestroy(): void {
    document.removeEventListener("visibilitychange", this.onTabSwitch, true)
    this.previewSubscription.unsubscribe();
    // if(this.isTemplateChanged == true) {
    //   this.updateForm("SAVE")
    //   this.isTemplateChanged = false;
    //   this.saveValidityCheck = true;
    // }
  } 

  canDeactivate(): Observable<boolean> | boolean {
    if(this.isTemplateChanged == true) {
      if(this.passwordEnabled == true && (this.password == "" || this.password.length == 0)) {
        this.isFormvalid = false;
      }
      if(this.onFocusOutTopicsSubTopics()) {
        this.isFormvalid = false;
      }
      if(this.isFormvalid == true) {
        this.updateForm("SAVE")
        this.isTemplateChanged = false;
        this.saveValidityCheck = true;
        if(this.isFormvalid == true){
          return true
        } else {
          return false
        } 
      } else {
        return false;
      }
    }
    return true;
    
  }

  oninit(): void {
    if (localStorage.getItem('bgTextColor')) this.bgTextColor = localStorage.getItem("bgTextColor");
    if (localStorage.getItem('bgColor')) this.bgColor = localStorage.getItem("bgColor");
    // Renders parent form tags
    this.newFormTemplate = this._formBuilderService.getNewFormTemplate();
    let newGenerateForm = {};
    newGenerateForm = document.createElement('div');
    newGenerateForm['innerHTML'] = this.newFormTemplate;
    this._renderer.appendChild(this.formBuilder.nativeElement, newGenerateForm);

    // Check if it's new form or edit form
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['id']) {
        this.templateEdit = true;
        this.templateId = params['id'];
        this._formService.getTemplateById(this.templateId).subscribe((response) => {
          if (response['success']) {
            this.templateId = response['data'][0]['_id']
            this.templateVersion = response['data'][0]['template_version']
            if (response['data'][0].template_schema && response['data'][0].template_schema.schema) {
              this.template = response['data'][0].template_schema.schema;
              let previewTemplate = response['data'][0].template_schema
              previewTemplate['formName'] = response['data'][0].name;
              previewTemplate['templateId'] = this.templateId
              previewTemplate['template_version'] = this.templateVersion
              this._sharedService.changeTemplate(response['data'][0].template_schema);
            }
            if (this.template) {
              let topicIndex = this.template.findIndex(field => field.key === "topic");
              this.topicTitle = this.template[topicIndex]["label"];
            }
            this.hashedPassword = response["data"][0]["hashed_password"];
            this.password = response["data"][0]["hashed_password"];
            this.passwordsalt = response["data"][0]["salt"];
            this.isEmbeddable = response["data"][0]["is_embeddable"];
            this.embeddable_link = response["data"][0]["embed_link"];
            this.isDefault = response["data"][0]["is_default"];
            this.templateName = response['data'][0].name;
            if (response["data"][0]["auth_required"]) {
              this.hashedPasswordExists = true;
              this.passwordEnabled = true;
              this.passwordHistory = true;
            } else {
              this.passwordEnabled = false;
              this.passwordHistory = false;
            }

            this.is_archived = response["data"][0]["is_archived"];
            this.is_deleted = response["data"][0]["is_deleted"];
            if (this.is_archived || this.is_deleted) {
              this.hideButtons = true;
              this.isDefault = true;
            }
            let formData = [];
            if (this.template) {
              formData = this.template;
            }
            // Parsing the form content
            this.formData = this._formBuilderService.generateHTMLFromTemplate(formData, this.templateName, { passwordEnabled: this.passwordEnabled });
            _.forEach(this.formData, (element) => {
              let template = this.getNodes(element.template);
              template[0]["id"] = "field-" + this.generateRandomString();
              $('.page').append(template);
            });

            if (!this.passwordEnabled) {
              let passwordField = document.getElementById("password");
              $(passwordField).hide();
              let passwordCheckbox = document.getElementById("passwordCheckbox");
              passwordCheckbox["checked"] = false;
            }
          }
        });
      } else {
        // Generate htmls for formtemplate
        this.formData = this._formBuilderService.generateHTMLFromTemplate([], "", this.password);
        _.forEach(this.formData, (element) => {
            let template = this.getNodes(element.template);
            template[0]["id"] = "field-" + this.generateRandomString();
            $('.page').append(template);
        });
      }
    });
  }

  // Method will take the Html String and returns Arrays of DOM (take first element)
  getNodes(template) {
    return new DOMParser().parseFromString(template, "text/html").body.childNodes;
  }

  // Generate random string - (fields)
  generateRandomString() {
    return uuid();
  }

  openAddNewItemPopupModal(event) {
    event.stopPropagation()
    event.preventDefault()
    if(this.highlightedElementId && this.highlightedElementId.includes("emptyfield")) {
      this.openValidationError({
        message:"Please select a new item.",
      })
      this.isFormvalid = false;
      return;
    }
    let path = event.path
    if (!event.path) {
      path = event.composedPath();
    }
    let addNewItemId = path[1].id
    let elementId = this.addNewItemToFormComponent.addEmptyField(addNewItemId)
    this.makeElementHighlightById(elementId);
  }

  navToHome(): void {
    this._router.navigate([localStorage.getItem("organizationCode") + "dashboard"]);
  }

  navToSortForms(): void {
    this._router.navigate(["sort-forms"]);
  }


  reorderDragStart($event) {
    $event.dataTransfer.effectAllowed = 'move';
    if ($event.target.nodeName === "IMG") {
      return;
    }
    this.dragType = "field";
    this.element = $event.target;
  }

  reorderTopicDragStart($event) {
    $event.dataTransfer.effectAllowed = 'move';
    if ($event.target.nodeName === "IMG") {
      return;
    }
    if (this.dragType.length === 0) {
      this.dragType = "topic";
    }
    this.element = $event.target;
  }

  reorderSubTopicDragStart($event) {
    $event.dataTransfer.effectAllowed = 'move';
    if ($event.target.nodeName === "IMG") {
      return;
    }
    this.dragType = "subtopic";
    this.element = $event.target;
  }

  reorderDragOver($event, type) {
    if (this.dragType !== "field") {
      $event.preventDefault();
      return;
    }
    if (this.element === undefined || this.element === null) {
      $event.preventDefault();
      return;
    } else {
        if ($event.target) {
          if (this.element === $event.currentTarget) {
            return;
          }

          if (type === "node") {
            if (this.isBefore(this.element, $event.currentTarget)) {
              document.getElementById('page').insertBefore(this.element, $event.currentTarget);
            } else {
              document.getElementById('page').insertBefore(this.element, $event.currentTarget.nextSibbling);
            }
          } else {
            if (this.isBefore(this.element, $event.currentTarget)) {
              let ele = document.getElementById(this.element.offsetParent.id);
              document.getElementById(this.element.offsetParent.id).insertBefore(this.element, $event.currentTarget);
            } else {
              document.getElementById(this.element.offsetParent.id).insertBefore(this.element, $event.currentTarget);
            }
          }
          return;
        }
    }
    this.enableUpdateButton();
  }

  reorderTopicDragOver($event, type) {
    if (this.dragType !== "topic") {
      $event.preventDefault();
      return;
    }
    if (this.element === undefined || this.element === null) {
        $event.preventDefault();
        return;
    } else {
        if ($event.target) {
          if (this.element === $event.currentTarget) {
            return;
          }

          if (this.isBefore(this.element, $event.currentTarget)) {
            document.getElementById("madatory-fields").insertBefore(this.element, $event.currentTarget);
          } else {
            document.getElementById('madatory-fields').insertBefore(this.element, $event.currentTarget.nextSibbling);
          }
        }
    }
    // this.enableUpdateButton();
  }

  reorderSubTopicDragOver($event, type) {
    if (this.dragType !== "subtopic") {
      $event.preventDefault();
      return;
    }
    if (this.element === undefined || this.element === null) {
      $event.preventDefault();
      return;
    } else {
        if ($event.target) {
          if (this.element === $event.currentTarget) {
            return;
          }

          if (this.element.offsetParent.id !== $event.currentTarget.offsetParent.id) {
            $event.preventDefault();
            this.element.style.cursor = "no-drop";
            return;
          } else {
            if (this.isBefore(this.element, $event.currentTarget)) {
              document.getElementById(this.element.offsetParent.id).insertBefore(this.element, $event.currentTarget);
            } else {
              document.getElementById(this.element.offsetParent.id).insertBefore(this.element, $event.currentTarget);
            }
          }
        }
    }
    this.enableUpdateButton();
  }
  reorderDragEnd() {
    if (this.element) {
      this.element.style.cursor = "all-scroll";
      this.element = null;
    }
    this.dragType = "";
    this.enableUpdateButton()
  }

  isBefore(element1, element2) {
    if (element2.parentNode === element1.parentNode){
      for (let cur = element1.previousSibling; cur; cur = cur.previousSibling)
        if (cur === element2) return true;
    } else {
      return false;
    }
  }

  openTopicConfigModal(event, type) {
    if (this.highlightedElementId && this.highlightedElementId.includes("emptyfield")) {
      this.isFormvalid = false;
      return;
    }
    if (!this.is_archived && !this.is_deleted) {
      let topicElement = document.getElementById(event.srcElement.offsetParent.offsetParent.id);
      let emailOptions = topicElement["children"][3]["attributes"]["data-options-email"]["nodeValue"];
      let phoneOptions = topicElement["children"][3]["attributes"]["data-options-phone"]["nodeValue"];
      const dialogRef = this.dialog.open(FieldPropertiesComponent, {
        width: '500px',
        data: {
          type: type,
          element: event.srcElement.offsetParent.offsetParent.id,
          title: "",
          fieldEmailOptions: emailOptions,
          fieldPhoneOptions: phoneOptions,
          fieldCheckBoxes: "",
          fieldSelectOptions: "",
          fieldRequired: "",
          new: false
        },
        disableClose: true
      });
      this.isTemplateChanged = true

      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  openSubTopicConfigModal(event, type) {
    if (this.highlightedElementId && this.highlightedElementId.includes("emptyfield")) {
      this.isFormvalid = false;
      return;
    }
    if (!this.is_archived && !this.is_deleted) {
      let emailOptions = $('#' + event.srcElement.offsetParent.offsetParent.id + ' :input').attr('data-options-email');
      let phoneOptions = $('#' + event.srcElement.offsetParent.offsetParent.id + ' :input').attr('data-options-phone');
      const dialogRef = this.dialog.open(FieldPropertiesComponent, {
        width: '500px',
        data: {
          type: type,
          element: event.srcElement.offsetParent.offsetParent.id,
          title: "",
          fieldEmailOptions: emailOptions,
          fieldPhoneOptions: phoneOptions,
          fieldCheckBoxes: "",
          fieldSelectOptions: "",
          fieldRequired: "",
          new: false
        },
        disableClose: true
      });
      this.isTemplateChanged = true
      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  // Removes form field
  deleteField(event, type?) {
    this.isTemplateChanged = true
    let path = event.path
    let deleteField;
    if (!event.path) {
      path = event.composedPath();
    } 
    deleteField = type && type == "subtopic" ? path[2] : path[3];
    if(deleteField && deleteField["id"] == this.highlightedElementId) {
      this.highlightedElementId = undefined;
    }
    deleteField.remove();
    this.enableUpdateButton();
  }

  // Removes form topic field
  deleteTopicField(event) {
    if(this.highlightedElementId && this.highlightedElementId.includes("emptyfield")) {
      this.isFormvalid = false;
      return;
    }

    // Getting the whole topic field div id
    this.isTemplateChanged = true
    let currentTopicId = event.currentTarget.parentElement.parentElement.id

    let body = "";
    let childNodes = document.getElementById(currentTopicId).children
    body = childNodes && childNodes.length > 5 ? "Are you sure you want to delete this topic and subtopics in it?" : "Are you sure you want to delete this topic?";
    this.ngZone.run(() => {
      this._sharedService.confirmationDialog(
        body,
        () => {
          document.getElementById(currentTopicId).remove()
        }
      );
    });
    this.enableUpdateButton();
  }

  updateForm(saveType?): any {
    this.isForTelmplatePreview = false;
    this.saveValidityCheck = true;
    let template_schema = this.createSchemaFromHtml ();
    if(template_schema && template_schema['schema'] && template_schema['schema'].length > 0) {
      this.topics = template_schema['schema'][1]
    } else {
      return;
    }
    if(this.onFocusOutTopicsSubTopics()) {
      this.isFormvalid = false;
      return;
    }
    let isFormNameChanged;
    let templateName = $('#form-name').val();
    if(saveType && saveType == "SAVE") {
      isFormNameChanged = templateName != this.templateName
    }
    if(!templateName || (templateName && templateName.length == 0)) {
      // this.openSnackBar("Please fill the form name")
      this.isFormvalid = false;
      let errorObj = {
        message: "Please enter title for Form Name field.",
        content: `Hint: Give a name to the form "EMPLOYMENT APPLICATION" "CONTACT US"`,
        domElement: document.getElementById('form-name')
      }
      this.openValidationError(errorObj);
      return;
    }
    if (this.passwordHistory !== this.passwordEnabled) this.saveValidityCheck = true;
    if (this.passwordEnabled) {
      if (this.password.length === 0) {
        if (this.hashedPassword.length === 0) {
          let errorObj = {
            message: "Please create a Password",
            content: `Hint: It is optional to require a Password to access a form. A Password can be created by toggling ‘Active on Form’. This function adds a little bit of security for sensitive forms.`,
            domElement: document.getElementById('passwordShow')
          }
          this.openValidationError(errorObj);
          return;
        }
      }
    }
    if (this.saveValidityCheck) {
      // Creating request object
      let requestData = {
        name: this.templateName != templateName ? templateName : this.templateName,
        code: this.generateRandomCode(),
        organization: localStorage.getItem('organization'),
        updated_at: Date.now(),
        is_archived: false,
        is_embeddable: false,
        auth_required: false,
        embed_link: this.embedLink ? this.embedLink : "",
        hashed_password: this.hashedPassword ? this.hashedPassword : "",
        salt: this.passwordsalt ? this.passwordsalt : "",
        template_schema: template_schema,
        templateId: this.templateId,
        version: this.templateVersion != undefined || this.templateName != "" ? parseInt(this.templateVersion.replace(/^\D+/g, '')) : 0,
        saveType: saveType ? saveType : undefined 
      };

      if (!this.compareSchemas(this.template, template_schema.schema)) {
        if (templateName == this.templateName && this.passwordHistory === this.passwordEnabled) {
          this.formUpdated = false;
          if(saveType == "DRAFT") {
            return;
          }
        } else {
          this.passwordHistory = this.passwordEnabled;
        }
      }

      if(isFormNameChanged) {
        requestData['isFormNameChanged'] = true
      }

      if (this.passwordEnabled) {
        requestData.auth_required = true;
        requestData.hashed_password = this.password;
      }
      // API call
      if(this.isTemplateChanged == true) {
        this._formService.updateTemplate(requestData).subscribe((response) => {
          if (response['success']) {
            this.isFormvalid = true;
            this.saveValidityCheck = true;
            if(saveType && saveType == "SAVE") {
              this.templateName = templateName
            } else {
              this.openSnackBar("Form saved successfully");
            }
            let orgid = localStorage.getItem('organizationCode');
            this.formUpdated = false;
            if (this.passwordEnabled && this.isPasswordChanged == true && saveType != "DRAFT") {
              if (this.password && this.password.length > 0) {
                this._sortFormService.setPasswordToTemplate({ password: this.password, templateId: this.templateId }).subscribe((response) => {
                  if(response['success']) {
                    this.isPasswordChanged = false;
                    this.hashedPassword = response["response"]["hashed_password"];
                    this.passwordsalt = response["response"]["salt"]
                  }
                });
              }
            }
          } else {
            this.openSnackBar(response["message"]);
          }
        });
      }
    }
  }

  createSchemaFromHtml() {
    const component = this;
    let topics = [];
    let subtopics = [];
    let template_schema = {
      schema: []
    };

    let index = 0;

    let contactTypeIndex = 0;

    let templateName;
    // Get all the elements in the field
    $("#page").find(":input").each(function() {
      if (this.dataset.type != "create-topic-btn" && this.dataset.type != "empty-field" && (this.dataset.key === 'name' ||
          this.dataset.key === 'password' ||
          this.dataset.key === 'readtext' ||
          this.dataset.key === 'topic' ||
          this.dataset.key === 'subtopic' ||
          this.dataset.key === 'subject' ||
          this.dataset.key === 'employeename')) {
        let key = this.dataset.key;
        if (key === "name") {
          templateName = this.dataset.placeholder;
          // component.templateName = this.dataset.placeholder;
          return;
        } else if (key === "password") {
          if (component.passwordEnabled) {
            if (component.validateForm(this.dataset, this)) {
              Window['app'].isFormvalid = false;
              return false;
            }
          }
        }
        if (key === "topic") {
          let obj = {
            label: this.dataset.title,
            placeholder: "",
            value: this.dataset.id,
            visible: true,
            options: [],
            ccEmail: [],
            ccPhone: []
          }
          if(component.isForTelmplatePreview == false) {
            if (obj.label.length === 0) {
              component.openValidationError("Please enter title for Topic field");
              component.saveValidityCheck = false;
              return false;
            } else if (obj.label.length < 2) {
              component.openValidationError("Topic title should be more than 1 characters");
              component.saveValidityCheck = false;
              return false;
            }
          }

          const emailData = this.dataset.optionsEmail;
          const phoneData = this.dataset.optionsPhone;

          if (emailData && emailData.length > 0) {
            const parsedEmails = JSON.parse(emailData);
            obj.ccEmail = parsedEmails;
          }

          if (phoneData && phoneData.length > 0) {
            const parsedPhones = JSON.parse(phoneData);
            obj.ccPhone = parsedPhones;
          }

          topics.push(obj);
          // return;
        } else if (key === "subtopic") {
          let label = this.dataset.title;
          let obj = {
            id: this.dataset.id,
            label: this.dataset.title,
            visible: true,
            value: label.toLowerCase(),
            ccEmail: [],
            ccPhone: []
          }
          if(component.isForTelmplatePreview == false) {
            if (obj.label.length === 0) {
              component.openValidationError("Please enter title for Subtopic field");
              component.saveValidityCheck = false;
              return false;
            } else if (obj.label.length < 2) { 
              component.openValidationError("Subtopic title should be more than 1 characters");
              component.saveValidityCheck = false;
              return false;
            }
          }
          const emailData = this.dataset.optionsEmail;
          const phoneData = this.dataset.optionsPhone;

          if (emailData && emailData.length > 0) {
            const parsedEmails = JSON.parse(emailData);
            obj.ccEmail = parsedEmails;
          }

          if (phoneData && phoneData.length > 0) {
            const parsedPhones = JSON.parse(phoneData);
            obj.ccPhone = parsedPhones;
          }

          subtopics.push(obj);
        } else if (key === "subject" || key === "employeename") {
          if(component.isForTelmplatePreview == false) {
            if(component.validateForm(this.dataset, this)) {
              return false;
            }
          }
          let schemaElement = {
            label: key == "employeename" ? this.dataset.placeholder: this.dataset.label,
            // placeholder: this.dataset.placeholder,
            placeholder: "",
            key: this.dataset.key,
            type: (key === "subject") ? 'textarea' : this.dataset.type,
            validate: {
              required: (this.dataset.required === "true") ? true : false,
              minlength: 1,
              maxlength: (key === "subject") ? 300 : 50
            },
          };
          template_schema.schema.push(schemaElement);
        } else if (key === "readtext") {
          if(component.isForTelmplatePreview == false) {
            if (component.validateForm(this.dataset, this)) {
              return false;
            }
          }

          let readTextKey = ""
          if (this.dataset.key.length > 0) {
            readTextKey =  this.dataset.key
          } else {
            readTextKey = component.generateFieldKey(this.dataset.label);
          }

          let key_index = "";
          if (this.dataset.key.length > 1) {
            key_index = readTextKey;
          } else {
            key_index = readTextKey + "_" + index;
          }
          if(component.isForTelmplatePreview == false) {
            if (this.dataset.label === "" && this.dataset.placeholder === "") {
              this.dataset.label = key_index;
              this.dataset.placeholder = key_index;
            }
          }

          let schemaElement = {
            label: this.dataset.placeholder,
            placeholder: this.dataset.placeholder,
            key: key_index,
            type: this.dataset.type,
            visible: (this.dataset.visible === "true") ? true : false,
            validate: {
              minlength: 1,
              maxlength: 50
            }
          };
          template_schema.schema.push(schemaElement);
        }
      } else if(this.dataset.type != "create-topic-btn" && this.dataset.type != "empty-field") {
        if (this.dataset.type === "text") {
          if(component.isForTelmplatePreview == false) {
            if (component.validateForm(this.dataset, this)) {
              return false;
            }
          }
          var key = "";

          if (this.dataset.key.length > 0) {
            key =  this.dataset.key
          } else {
            key = component.generateFieldKey(this.dataset.label);
          }

          let key_index = "";
          if (this.dataset.key.length > 1) {
            key_index = key;
          } else {
            key_index = key + "_" + index;
          }
          if(component.isForTelmplatePreview == false) {
            if (this.dataset.label === "" && this.dataset.placeholder === "") {
              this.dataset.label = key_index;
              this.dataset.placeholder = key_index;
            }
          }

          let schemaElement = {
            label: this.dataset.placeholder,
            placeholder: this.dataset.placeholder,
            key: key_index,
            type: this.dataset.type,
            visible: (this.dataset.visible === "true") ? true : false,
            validate: {
              required: (this.dataset.required === "true") ? true : false,
              minlength: 1,
              maxlength: 50
            }
          };
          template_schema.schema.push(schemaElement);
        } else if (this.dataset.type === "textarea") {
          if(component.isForTelmplatePreview == false) {
            if (component.validateForm(this.dataset, this)) {
              return false;
            }
          }
          var key = "";
          // if (this.dataset.label.length > 1) {
          //   key =  this.dataset.label.replace(/\W+/g, " ")
          //   .split(/ |\B(?=[A-Z])/)
          //   .map(word => word.toLowerCase())
          //   .join('_');
          // } else {
          //   key =  ('Field Title').replace(/\W+/g, " ")
          //   .split(/ |\B(?=[A-Z])/)
          //   .map(word => word.toLowerCase())
          //   .join('_');
          // }

          // let key_index = key + "_" + index;
          if (this.dataset.key.length > 0) {
            key =  this.dataset.key
          } else {
            key = component.generateFieldKey(this.dataset.label);
          }

          let key_index = "";
          if (this.dataset.key.length > 1) {
            key_index = key;
          } else {
            key_index = key + "_" + index;
          }
          if(component.isForTelmplatePreview == false) {
            if (this.dataset.label === "" && this.dataset.placeholder === "") {
              this.dataset.label = key_index;
              this.dataset.placeholder = key_index;
            }
          }

          let schemaElement = {
            label: this.dataset.placeholder,
            placeholder: this.dataset.placeholder,
            key: key_index,
            type: this.dataset.type,
            visible: (this.dataset.visible === "true") ? true : false,
            validate: {
              required: (this.dataset.required === "true") ? true : false,
              minlength: 1,
              maxlength: 350
            }
          };
          template_schema.schema.push(schemaElement);
        } else if (this.dataset.type === "email") {
          if(component.isForTelmplatePreview == false) {
            if (component.validateForm(this.dataset, this)) {
              return false;
            }
          }
          var key = "";

          if (this.dataset.key.length > 0) {
            key =  this.dataset.key
          } else {
            key = component.generateFieldKey(this.dataset.label);
          }

          let key_index = "";
          if (this.dataset.key.length > 1) {
            key_index = key;
          } else {
            key_index = key + "_" + index;
          }
          if(component.isForTelmplatePreview == false) {
            if (this.dataset.label === "" && this.dataset.placeholder === "") {
              this.dataset.label = key_index;
              this.dataset.placeholder = key_index;
            }
          }

          let schemaElement = {
            label: this.dataset.placeholder,
            placeholder: this.dataset.placeholder,
            key: key_index,
            type: this.dataset.type,
            visible: (this.dataset.visible === "true") ? true : false,
            validate: {
              required: (this.dataset.required === "true") ? true : false,
              minlength: 1,
              maxlength: 50
            }
          };
          template_schema.schema.push(schemaElement);
        } else if (this.dataset.type === "phone") {
          if(component.isForTelmplatePreview == false) {
            if (component.validateForm(this.dataset, this)) {
              return false;
            }
          }
          var key = "";

          if (this.dataset.key.length > 0) {
            key =  this.dataset.key
          } else {
            key = component.generateFieldKey(this.dataset.label);
          }

          let key_index = "";
          if (this.dataset.key.length > 1) {
            key_index = key;
          } else {
            key_index = key + "_" + index;
          }
          if(component.isForTelmplatePreview == false) {
            if (this.dataset.label === "" && this.dataset.placeholder === "") {
              this.dataset.label = key_index;
              this.dataset.placeholder = key_index;
            }
          }

          let schemaElement = {
            label: this.dataset.placeholder,
            placeholder: this.dataset.placeholder,
            key: key_index,
            type: this.dataset.type,
            visible: (this.dataset.visible === "true") ? true : false,
            validate: {
              required: (this.dataset.required === "true") ? true : false,
              minlength: 1,
              maxlength: 50
            }
          };
          template_schema.schema.push(schemaElement);
        } else if (this.dataset.type === "radio") {
          if(component.isForTelmplatePreview == false) {
            if (component.validateForm(this.dataset, this)) {
              return false;
            }
          }
          var key = "";
          // if (this.dataset.label.length > 1) {
          //   key =  this.dataset.label.replace(/\W+/g, " ")
          //   .split(/ |\B(?=[A-Z])/)
          //   .map(word => word.toLowerCase())
          //   .join('_');
          // } else {
          //   key =  ('Field Title').replace(/\W+/g, " ")
          //   .split(/ |\B(?=[A-Z])/)
          //   .map(word => word.toLowerCase())
          //   .join('_');
          // }

          // let key_index = key + "_" + index;

          if (this.dataset.key.length > 0) {
            key =  this.dataset.key
          } else {
            key = component.generateFieldKey(this.dataset.label);
          }

          let key_index = "";
          if (this.dataset.key.length > 1) {
            key_index = key;
          } else {
            key_index = key + "_" + index;
          }

          if(component.isForTelmplatePreview == false) {
            if (this.dataset.label === "" && this.dataset.placeholder === "") {
              this.dataset.label = key_index;
              this.dataset.placeholder = key_index;
            }
          }

          let schemaElement = {
            label: this.dataset.placeholder,
            placeholder: this.dataset.placeholder,
            key: key_index,
            type: this.dataset.type,
            visible: (this.dataset.visible === "true") ? true : false,
            validate: {
              required: (this.dataset.required === "true") ? true : false
            },
            data: JSON.parse(this.dataset.options)
          };
          template_schema.schema.push(schemaElement);
        } else if (this.dataset.type === "checkbox") {
          if(component.isForTelmplatePreview == false) {
            if (component.validateForm(this.dataset, this)) {
              return false;
            }
          }
          var key = "";
          // if (this.dataset.label.length > 1) {
          //   key =  this.dataset.label.replace(/\W+/g, " ")
          //   .split(/ |\B(?=[A-Z])/)
          //   .map(word => word.toLowerCase())
          //   .join('_');
          // } else {
          //   key =  ('Field Title').replace(/\W+/g, " ")
          //   .split(/ |\B(?=[A-Z])/)
          //   .map(word => word.toLowerCase())
          //   .join('_');
          // }

          // let key_index = key + "_" + index;

          if (this.dataset.key.length > 0) {
            key =  this.dataset.key
          } else {
            key = component.generateFieldKey(this.dataset.label);
          }

          let key_index = "";
          if (this.dataset.key.length > 1) {
            key_index = key;
          } else {
            key_index = key + "_" + index;
          }

          if(component.isForTelmplatePreview == false) {
            if (this.dataset.label === "" && this.dataset.placeholder === "") {
              this.dataset.label = key_index;
              this.dataset.placeholder = key_index;
            }
          }

          let schemaElement = {
            label: this.dataset.placeholder,
            placeholder: this.dataset.placeholder,
            key: key_index,
            type: this.dataset.type,
            visible: (this.dataset.visible === "true") ? true : false,
            validate: {
              required: (this.dataset.required === "true") ? true : false
            },
            defaultValue: (this.dataset.options === "true") ? true : false
          };
          template_schema.schema.push(schemaElement);
        }  else if (this.dataset.type === "select") {
          if(component.isForTelmplatePreview == false) {
            if (component.validateForm(this.dataset, this)) {
              return false;
            }
          }
          var key = "";
          // if (this.dataset.label.length > 1) {
          //   key =  this.dataset.label.replace(/\W+/g, " ")
          //   .split(/ |\B(?=[A-Z])/)
          //   .map(word => word.toLowerCase())
          //   .join('_');
          // } else {
          //   key =  ('Field Title').replace(/\W+/g, " ")
          //   .split(/ |\B(?=[A-Z])/)
          //   .map(word => word.toLowerCase())
          //   .join('_');
          // }

          // let key_index = key + "_" + index;
          if (this.dataset.key.length > 0) {
            key =  this.dataset.key
          } else {
            key = component.generateFieldKey(this.dataset.label);
          }

          let key_index = "";
          if (this.dataset.key.length > 1) {
            key_index = key;
          } else {
            key_index = key + "_" + index;
          }
          if(component.isForTelmplatePreview == false) {
            if (this.dataset.label === "" && this.dataset.placeholder === "") {
              this.dataset.label = key_index;
              this.dataset.placeholder = key_index;
            }
          }

          let schemaElement = {
            label: this.dataset.placeholder,
            placeholder: this.dataset.placeholder,
            key: key_index,
            type: this.dataset.type,
            visible: (this.dataset.visible === "true") ? true : false,
            validate: {
              required: (this.dataset.required === "true") ? true : false
            },
            data: JSON.parse(this.dataset.options)
          };

          template_schema.schema.push(schemaElement);
        } else if (this.dataset.type === "picture") {
          if(component.isForTelmplatePreview == false) {
            if (component.validateForm(this.dataset, this)) {
              return false;
            }
          }
          var key = "";
          // if (this.dataset.label.length > 1) {
          //   key =  this.dataset.label.replace(/\W+/g, " ")
          //   .split(/ |\B(?=[A-Z])/)
          //   .map(word => word.toLowerCase())
          //   .join('_');
          // } else {
          //   key =  ('Field Title').replace(/\W+/g, " ")
          //   .split(/ |\B(?=[A-Z])/)
          //   .map(word => word.toLowerCase())
          //   .join('_');
          // }

          // let key_index = key + "_" + index;

          if (this.dataset.key.length > 0) {
            key =  this.dataset.key
          } else {
            key = component.generateFieldKey(this.dataset.label);
          }

          let key_index = "";
          if (this.dataset.key.length > 1) {
            key_index = key;
          } else {
            key_index = key + "_" + index;
          }
          if(component.isForTelmplatePreview == false) {
            if (this.dataset.label === "" && this.dataset.placeholder === "") {
              this.dataset.label = key_index;
              this.dataset.placeholder = key_index;
            }
          }


          let schemaElement = {
            label: this.dataset.placeholder,
            placeholder: this.dataset.placeholder,
            key: key_index,
            type: this.dataset.type,
            visible: (this.dataset.visible === "true") ? true : false,
            validate: {
              required: (this.dataset.required === "true") ? true : false
            }
          };

          template_schema.schema.push(schemaElement);
        } else if (this.dataset.type === "file") {
          if(component.isForTelmplatePreview == false) {
            if (component.validateForm(this.dataset, this)) {
              return false;
            }
          }
          var key = "";
          // if (this.dataset.label.length > 1) {
          //   key =  this.dataset.label.replace(/\W+/g, " ")
          //   .split(/ |\B(?=[A-Z])/)
          //   .map(word => word.toLowerCase())
          //   .join('_');
          // } else {
          //   key =  ('Field Title').replace(/\W+/g, " ")
          //   .split(/ |\B(?=[A-Z])/)
          //   .map(word => word.toLowerCase())
          //   .join('_');
          // }

          // let key_index = key + "_" + index;

          if (this.dataset.key.length > 0) {
            key =  this.dataset.key
          } else {
            key = component.generateFieldKey(this.dataset.label);
          }

          let key_index = "";
          if (this.dataset.key.length > 1) {
            key_index = key;
          } else {
            key_index = key + "_" + index;
          }
          if(component.isForTelmplatePreview == false) {
            if (this.dataset.label === "" && this.dataset.placeholder === "") {
              this.dataset.label = key_index;
              this.dataset.placeholder = key_index;
            }
          }

          let schemaElement = {
            label: this.dataset.placeholder,
            placeholder: this.dataset.placeholder,
            key: key_index,
            type: this.dataset.type,
            visible: (this.dataset.visible === "true") ? true : false,
            validate: {
              required: (this.dataset.required === "true") ? true : false
            }
          };

          template_schema.schema.push(schemaElement);
        } else if (this.dataset.type === "question") {
          if(component.isForTelmplatePreview == false) {
            if (component.validateForm(this.dataset, this)) {
              return false;
            }
          }
          var key = "";
          // if (this.dataset.label.length > 1) {
          //   key =  this.dataset.label.replace(/\W+/g, " ")
          //   .split(/ |\B(?=[A-Z])/)
          //   .map(word => word.toLowerCase())
          //   .join('_');
          // } else {
          //   key =  ('Field Title').replace(/\W+/g, " ")
          //   .split(/ |\B(?=[A-Z])/)
          //   .map(word => word.toLowerCase())
          //   .join('_');
          // }

          // let key_index = key + "_" + index;
          if (this.dataset.key.length > 0) {
            key =  this.dataset.key
          } else {
            key = component.generateFieldKey(this.dataset.label);
          }

          let key_index = "";
          if (this.dataset.key.length > 1) {
            key_index = key;
          } else {
            key_index = key + "_" + index;
          }
          if(component.isForTelmplatePreview == false) {
            if (this.dataset.label === "" && this.dataset.placeholder === "") {
              this.dataset.label = key_index;
              this.dataset.placeholder = key_index;
            }
          }

          let schemaElement = {
            label: this.dataset.placeholder,
            placeholder: this.dataset.placeholder,
            key: key_index,
            type: this.dataset.type,
            visible: (this.dataset.visible === "true") ? true : false,
            validate: {
              required: (this.dataset.required === "true") ? true : false
            },
            data: JSON.parse(this.dataset.options)
          };

          template_schema.schema.push(schemaElement);
        } else if (this.dataset.type === "contact") {
          if(component.isForTelmplatePreview == false) {
            if (component.validateForm(this.dataset, this)) {
              return false;
            }
          }
          let key = "contact_" + contactTypeIndex;
          contactTypeIndex = contactTypeIndex + 1;

          if(component.isForTelmplatePreview == false) {
            if (this.dataset.label === "" && this.dataset.placeholder === "") {
              this.dataset.label = key;
              this.dataset.placeholder = key;
            }
          }

          let schemaElement = {
            label: this.dataset.placeholder,
            placeholder: this.dataset.placeholder,
            key: key,
            type: this.dataset.type,
            visible: (this.dataset.visible === "true") ? true : false,
            validate: {
              required: (this.dataset.required === "true") ? true : false
            },
            data: [{
              checked: false
            }]
          };

          template_schema.schema.push(schemaElement);
        } else if (this.dataset.type === "address") {
          if(component.isForTelmplatePreview == false) {
            if (component.validateForm(this.dataset, this)) {
              return false;
            }
          }
          var key = "";

          if (this.dataset.key.length > 0) {
            key =  this.dataset.key
          } else {
            key = component.generateFieldKey(this.dataset.label);
          }

          let key_index = "";
          if (this.dataset.key.length > 1) {
            key_index = key;
          } else {
            key_index = key + "_" + index;
          }
          if(component.isForTelmplatePreview == false) {
            if (this.dataset.label === "" && this.dataset.placeholder === "") {
              this.dataset.label = key_index;
              this.dataset.placeholder = key_index;
            }
          }

          let schemaElement = {
            label: this.dataset.placeholder,
            placeholder: this.dataset.placeholder,
            key: key_index,
            type: this.dataset.type,
            visible: (this.dataset.visible === "true") ? true : false,
            validate: {
              required: (this.dataset.required === "true") ? true : false
            }
          };
          template_schema.schema.push(schemaElement);
        } else if (this.dataset.type === "date") {
          if(component.isForTelmplatePreview == false) {
            if (component.validateForm(this.dataset, this)) {
              return false;
            }
          }
          var key = "";

          if (this.dataset.key.length > 0) {
            key =  this.dataset.key
          } else {
            key = component.generateFieldKey(this.dataset.label);
          }

          let key_index = "";
          if (this.dataset.key.length > 1) {
            key_index = key;
          } else {
            key_index = key + "_" + index;
          }
          if(component.isForTelmplatePreview == false) {
            if (this.dataset.label === "" && this.dataset.placeholder === "") {
              this.dataset.label = key_index;
              this.dataset.placeholder = key_index;
            }
          }

          let schemaElement = {
            label: this.dataset.placeholder,
            placeholder: this.dataset.placeholder,
            key: key_index,
            type: this.dataset.type,
            visible: (this.dataset.visible === "true") ? true : false,
            validate: {
              required: (this.dataset.required === "true") ? true : false
            }
          };
          template_schema.schema.push(schemaElement);
        } else if (this.dataset.type === "time") {
          if(component.isForTelmplatePreview == false) {
            if (component.validateForm(this.dataset, this)) {
              return false;
            }
          }
          var key = "";

          if (this.dataset.key.length > 0) {
            key =  this.dataset.key
          } else {
            key = component.generateFieldKey(this.dataset.label);
          }

          let key_index = "";
          if (this.dataset.key.length > 1) {
            key_index = key;
          } else {
            key_index = key + "_" + index;
          }
          if(component.isForTelmplatePreview == false) {
            if (this.dataset.label === "" && this.dataset.placeholder === "") {
              this.dataset.label = key_index;
              this.dataset.placeholder = key_index;
            }
          }

          let schemaElement = {
            label: this.dataset.placeholder,
            placeholder: this.dataset.placeholder,
            key: key_index,
            type: this.dataset.type,
            visible: (this.dataset.visible === "true") ? true : false,
            validate: {
              required: (this.dataset.required === "true") ? true : false
            }
          };
          template_schema.schema.push(schemaElement);
        }
      }
      index++;
    });

    if (this.topicTitle.length === 0) {
      let errorObj = {
        message: "Please enter title for Topic field.",
        content: `Hint: The Topic is the reason a user is filling out your form. The Topic will be the first thing on a form the user selects. A user will be able to select one Topic from a list of Topics`,
        domElement: document.getElementById("create-topic-input")
      }
      if(component.isForTelmplatePreview == false) {
        this.isFormvalid = false;
        this.openValidationError(errorObj);
        return;
      }
      component.saveValidityCheck = false;
    }
    let topicSchemaElement = {
      label: component.topicTitle,
      placeholder: "",
      key: "topic",
      type: 'select',
      validate: {
        required: topics && topics.length > 0 ? true : false
      },
      data: [],
      dependent_key: "subtopic"
    };

    topics.forEach(ele => {
      subtopics.forEach(subTopic => {
        if (ele.value === subTopic.id) {
          if (subTopic.label.length === 0) {
            if(component.isForTelmplatePreview == false) {
              this.openValidationError("Please enter subtopic title of " + ele.label + " topic");
              return true;
            }
            this.saveValidityCheck = false;
          }
          let obj = {
            label: subTopic.label,
            value: subTopic.value,
            visible: subTopic.visible,
            ccEmail: subTopic.ccEmail,
            ccPhone: subTopic.ccPhone
          }
          ele.options.push(obj);
        }
      });
    });

    topicSchemaElement.data = topics;

    // For subtopic
    let subTopicSchemaElement = {
      label: "Additional Information",
      placeholder: "",
      key: 'subtopic',
      type: 'select',
      validate: {
        required: topics && topics.length > 0 && subtopics && subtopics.length > 0 ? true : false
      },
      data: [],
      dependent_data: {}
    };

    let dependent_data = {}
    topics.forEach(ele => {
      dependent_data[ele.value] = []
      ele.options.forEach((subTopic) => {
        dependent_data[ele.value].push(subTopic);
      });
    });

    topics.forEach((topic) => {
      if (topic.label.length === 0) {
        let errorObj = {
          message: "Please enter title for Topic.",
          content: `Hint: The Topic is the reason a user is filling out your form. The Topic will be the first thing on a form the user selects. A user will be able to select one Topic from a list of Topics`,
          domElement: document.getElementById("create-topic-btn")
        }
        this.isFormvalid = false;
        
        if(component.isForTelmplatePreview == false) {
          this.openValidationError(errorObj);
        }
        this.saveValidityCheck = false;
        return;
      }
    })
    subTopicSchemaElement.dependent_data = dependent_data;
    template_schema.schema.splice(1, 0, topicSchemaElement);
    template_schema.schema.splice(2, 0, subTopicSchemaElement);
    this.topics = topicSchemaElement['data']

    let admin_field_existance = template_schema.schema.findIndex((element) => element.type === "admin_notes");

    if (admin_field_existance === -1) {
      let admin_notes = {
        "label": "Admin Notes",
        "placeholder": "",
        "key": "admin_notes",
        "type": "admin_notes"
      };

      template_schema.schema.push(admin_notes);
    }
    // Add admin_notes field
    // if (this.templateName !== templateName) {
    //   this.templateName = templateName
    //   this.saveValidityCheck = true;
    // }
    return template_schema;
  }

  compareSchemas(lhs, rhs) {
    let compare = diff(lhs, rhs);
    if (Object.keys(compare).length === 0) {
      return false;
    }
    this.template = rhs;
    return true;
  }

  validateForm(element, domElement?) {
    if (element.key === 'name') {
      if (element.label.length === 0) {
        // this.openValidationError("Enter form name");
        let errorObj = {
          message: "Please enter title for Form Name field.",
          content: `Hint: Give a name to the form "EMPLOYMENT APPLICATION" "CONTACT US"`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj);
        console.log("Enter form name");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      }
    } else if(element.key === 'readtext') {
      if((element.visible == true || element.visible == "true") && element.placeholder.length === 0) {
        // this.openValidationError("Please Enter Form Description/Instructions");
        let errorObj = {
          message: "Please enter a Form Description/Instructions",
          content: `Hint: Form Description/Instructions is a greeting message. It provides a personal touch to a user filling out your form. Example: “Thank you for filling out our form today”`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj);
        console.log("Enter read text name");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      }
    } else if (element.key === 'subject') {
      if (element.label.length === 0) {
        // this.openValidationError("Please enter title for Subject field");
        let errorObj = {
          message: "Please enter title for Comments field.",
          content: `Hint: The Comments field is a required Text Box. Like an email, the user uses the Comments Box to describe the reason for filling out the form.`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj);
        console.log("Please enter subject");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      }
    } else if (element.key === 'topic') {
      if (element.label.length === 0 || element.options.length === 0) {
        // this.openValidationError("Please add atleast one topic");
        let errorObj = {
          message: "Please add atleast one topic",
          content: `Hint: The Topic is the reason a user is filling out your form. The Topic will be the first thing on a form the user selects. A user will be able to select one Topic from a list of Topics`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj)
        console.log("Please add atleast one topic");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      }
    }  else if (element.key === 'employeename') {
      if (element.label.length === 0) {
        let errorObj = {
          message: "Please enter title for Name field.",
          content: `Hint: Name Field instructs the user where to put their name. You don’t have to use the word “name”. You can use a different language. Example: “Nombre”`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj);
        console.log("Please enter name field title");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      }
    } else if (element.key !== 'name' && element.key !== 'subject' && element.key !== 'topic' && element.key !== 'subject' && element.key !== 'password' && element.type === 'text') {
      if (element.label.length === 0) {
        this.openValidationError("Please enter title for Single-line text field");
        console.log("Please enter title for Single-line text field");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      }
    } else if (element.key !== 'name' && element.key !== 'subject' && element.key !== 'topic' && element.key !== 'subject' && element.key !== 'password' && element.type === 'textarea') {
      if (element.label.length === 0) {
        // this.openValidationError("Please enter title for Multi-line text field");
        let errorObj = {
          message: "Please create Text Box Title.",
          content: `Hint: A Text Box allows an individual filling out the form to use their own words. Create a Title that lets them know what you want from them. Example: “Tell us more about yourself”`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj);
        console.log("Please enter title for Multi-line text field");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      }
    } else if (element.key !== 'name' && element.key !== 'subject' && element.key !== 'topic' && element.key !== 'subject' && element.key !== 'password' && element.type === 'radio') {
      if (element.label.length === 0) {
        // this.openValidationError("Please enter field title for Option Buttons field");
        let errorObj = {
          message: "Please create Options Buttons Title",
          content: `Hint: Options Buttons are a great way to get specific information by asking a question that requires the user to pick an answer from a list of options. Example: “What is your shirt size?” The Options could include Small, Medium, Large, XL.`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj);
        console.log("Please enter field title for Option Buttons field");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      } else if (JSON.parse(element.options).length === 0) {
        // this.openValidationError("Please add options to " + element.label + " field");
        let errorObj = {
          message: "Please add options to " + element.label + " field",
          content: `Hint: Options Buttons are a great way to get specific information by asking a question that requires the user to pick an answer from a list of options. Example: “What is your shirt size?” The Options could include Small, Medium, Large, XL.`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj);
        console.log("Please add options");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      } else {
        for(let option of JSON.parse(element.options)) {
          if(option.value.length == 0) {
            this.openValidationError("Please enter option value for " + element.label + " field");
            this.saveValidityCheck = false;
            this.isFormvalid = false
            return true;
          }
        }
        let isHavingDuplicates = this.findDuplicateTopic(JSON.parse(element.options))

        if(isHavingDuplicates != false) {
          this.openValidationError(`${isHavingDuplicates} is already exist, please enter different option.`)
          return true;
        }
      }
    } else if (element.key !== 'name' && element.key !== 'subject' && element.key !== 'topic' && element.key !== 'subject' && element.key !== 'password' && element.type === 'checkbox') {
      if (element.label.length === 0) {
        this.openValidationError("Please enter title for Checkbox field");
        console.log("Please enter title for Checkbox field");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      }
    } else if (element.key !== 'name' && element.key !== 'subject' && element.key !== 'topic' && element.key !== 'subject' && element.key !== 'password' && element.type === 'select') {
      if (element.label.length === 0) {
        // this.openValidationError("Please enter title for Dropdown Box field");
        let errorObj = {
          message: "Please create Dropdown Box Title",
          content: `Hint: Dropdown Box is a great way to get specific information by asking a question that requires the user to pick an answer from a dropdown list. Example: “What is your favorite color?” The Options could include Red, Orange, Yellow, Green, Blue.`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj);

        console.log("Please enter title for Dropdown Box field");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      } else if (JSON.parse(element.options).length === 0) {
        // this.openValidationError("Please add options to " + element.label + " field");
        let errorObj = {
          message: "Please add options to " + element.label + " field",
          content: `Hint: Dropdown Box is a great way to get specific information by asking a question that requires the user to pick an answer from a dropdown list. Example: “What is your favorite color?” The Options could include Red, Orange, Yellow, Green, Blue.`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj);
        console.log("Please add options for Dropdown Box field");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      } else {
        for(let option of JSON.parse(element.options)) {
          if(option.value.length == 0) {
            this.openValidationError("Please enter option value for " + element.label + " field");
            this.saveValidityCheck = false;
            return true;
          }
        }
        let isHavingDuplicates = this.findDuplicateTopic(JSON.parse(element.options))

        if(isHavingDuplicates != false) {
          this.openValidationError(`${isHavingDuplicates} is already exist, please enter different option.`)
          return true;
        }
      }
    } else if (element.key !== 'name' && element.key !== 'subject' && element.key !== 'topic' && element.key !== 'subject' && element.key !== 'password' && element.type === 'picture') {
      if (element.label.length === 0) {
        // this.openValidationError("Please enter title for Picture Upload field");
        let errorObj = {
          message: "Please create Picture Upload Title.",
          content: `Hint: Picture Upload allows a user the ability to upload a photo. The title can be as simple as “Upload Photo” or something more personal as “Upload a photo of yourself”`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj);
        console.log("Please enter title for Picture Upload field");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      }
    } else if (element.key !== 'name' && element.key !== 'subject' && element.key !== 'topic' && element.key !== 'subject' && element.key !== 'password' && element.type === 'file') {
      if (element.label.length === 0) {
        // this.openValidationError("Please enter title for File Upload field");
        let errorObj = {
          message: "Please create File Upload Title",
          content: `Hint: File Upload allows a user the ability to upload a file (like a PDF). The title can be as simple as “Upload File” or some thing more custom as “Upload your Resume here”`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj);
        console.log("Please enter title for File Upload field");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      }
    } else if (element.key !== 'name' && element.key !== 'subject' && element.key !== 'topic' && element.key !== 'subject' && element.key !== 'password' && element.type === 'question') {
      if (element.label.length === 0) {
        // this.openValidationError("Please enter title for Question field");
        let errorObj = {
          message: "Please create Yes/No Title.",
          content: `Hint: Yes / No Button is a great way to get information. Asks a question that requires a Yes or No answer. Example: “Do you have work experience?”`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj);
        console.log("Please enter title for Question field");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      }
    } else if (element.key !== 'name' && element.key !== 'subject' && element.key !== 'topic' && element.key !== 'subject' && element.key !== 'password' && element.type === 'email') {
      if (element.label.length === 0) {
        // this.openValidationError("Please enter title for Email field");
        let errorObj = {
          message: "Please create Email Address Title",
          content: `Hint: The form is asking for an Email Address. You can make it as simple as “Email Address” or you can change it to something like “What is your Email Address?”`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj);
        console.log("Please enter title for Email field");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      }
    } else if (element.key !== 'name' && element.key !== 'subject' && element.key !== 'topic' && element.key !== 'subject' && element.key !== 'password' && element.type === 'phone') {
      if (element.label.length === 0) {
        // this.openValidationError("Please enter title for Phone field");
        let errorObj = {
          message: "Please create Phone Number Title",
          content: `Hint: The form is asking for an Phone Number. You can make it as simple as “Phone Number” or you can change it to something like “What is your Phone Number?”`,
          element,
          domElement     
        }
        
        this.openValidationError(errorObj);
        console.log("Please enter title for Phone field");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      }
    } else if (element.key !== 'name' && element.key !== 'subject' && element.key !== 'topic' && element.key !== 'subject' && element.key !== 'password' && element.type === 'contact') {
      if (element.label.length === 0) {
        // this.openValidationError("Please enter title for contact field");
        let errorObj = {
          message: "Please create Request to be Contacted Title",
          content: `Hint: This is where you can ask “would you like to be contacted?” If the user selects Yes, it then requires their Email and Phone number before completing the form. Example: “Do you want to hear back from us regarding this submission?”`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj);
        console.log("Please enter title for contactx field");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      }
    } else if (element.key !== 'name' && element.key !== 'subject' && element.key !== 'topic' && element.key !== 'subject' && element.key !== 'password' && element.type === 'address') {
      if (element.label.length === 0) {
        // this.openValidationError("Please enter title for Multi-line text field");
        let errorObj = {
          message: "Please create Address Title.",
          content: `Hint: This is where you can ask "Where do you live?" If the user selects Yes, It then requires their Flat No, City, State, Country and Zipcode before completing the form. Example: "Provide your address for order delivery."`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj);
        console.log("Please enter title for Address field");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      }
    } else if (element.key !== 'name' && element.key !== 'subject' && element.key !== 'topic' && element.key !== 'subject' && element.key !== 'password' && element.type === 'date') {
      if (element.label.length === 0) {
        // this.openValidationError("Please enter title for Multi-line text field");
        let errorObj = {
          message: "Please create Date Title.",
          content: `Hint: A date field allows an individual filling out the form to enter some date. Create a Title that lets them know what you want from them. Example: Date of Birth`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj);
        console.log("Please enter title for date field");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      }
    } else if (element.key !== 'name' && element.key !== 'subject' && element.key !== 'topic' && element.key !== 'subject' && element.key !== 'password' && element.type === 'time') {
      if (element.label.length === 0) {
        // this.openValidationError("Please enter title for Multi-line text field");
        let errorObj = {
          message: "Please create Time Title.",
          content: `Hint: A time field allows an individual filling out the form to enter some time. Create a Title that lets them know what you want from them. Example: “At what time ?”`,
          element,
          domElement
        }
        
        this.openValidationError(errorObj);
        console.log("Please enter title for time field");
        this.saveValidityCheck = false;
        this.isFormvalid = false
        return true;
      }
    }
    this.isFormvalid == true;
  }

  generateFieldKey(label) {
    let key ="";
    key = (label).replace(/\W+/g, " ")
      .split(/ |\B(?=[A-Z])/)
      .map(word => word.toLowerCase())
      .join('_');

    return key;
  }

  openValidationError(message) {
    this.ngZone.run(() => {
      const dialogRef = this.dialog.open(ValidationPopupComponent, {
        width: '500px',
        data: {
         content:  message
        },
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
        this.saveValidityCheck = true;
        if(result && result['element']) {
          result['element'].focus();
        }
      })
    });
  }

  generateRandomCode() {
    let randomString = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let charactersLength = characters.length;
    for ( let i = 0; i < 11; i++ ) {
      randomString += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return randomString;
  }

  onFormNameChange(event) {
    let path = event.path
    if (!event.path) {
      path = event.composedPath();
    }
    $("#" + path[1].id + " :input").attr("data-title", event.target.value);
    $("#" + path[1].id + " :input").attr("data-placeholder", event.target.value);
    $("#" + path[1].id + " :input").attr("value", event.target.value);
    this.enableUpdateButton(event.target.value);
  }

  onSubjectValueChange(event) {
    $("#subject").attr("data-title", event.target.value);
    $("#subject").attr("data-label", event.target.value);
    $("#subject").attr("data-placeholder", event.target.value);
    $("#subject").attr("value", event.target.value);
    this.enableUpdateButton();
  }

  onEmployeeNameChange(event) {
    $('#employeeName').attr("data-title", event.target.value);
    $('#employeeName').attr("data-label", event.target.value);
    $("#employeeName").attr("data-placeholder", event.target.value);
    $("#employeeName").attr("value", event.target.value);
    this.enableUpdateButton();
  }

  onFieldVisibilityChange(event) {
    let path = event.path;
    if (!event.path) {
      path = event.composedPath();
    }
    let fieldId = path[3].id;
    let dataVisibility = $("#" + fieldId + " :input").attr("data-visible");
    if (dataVisibility === "true") {
      $("#" + fieldId + " :input").attr("data-visible", false);
      $(path[0]).css('opacity', '0.3');
    } else {
      $("#" + fieldId + " :input").attr("data-visible", true);
      $(path[0]).css('opacity', '1');
    }
    this.enableUpdateButton();
  }

  showPassword(){
    let type = document.getElementById('passwordShow').attributes["type"].value;
    if(type === 'text')  {
      document.getElementById('passwordShow').attributes["type"].value = "password";
      document.getElementById('hidden').style.display = 'none';
      document.getElementById('visibility').style.display = 'block';
    }
    else{
      document.getElementById('passwordShow').attributes["type"].value = "text";
      document.getElementById('visibility').style.display = 'none';
      document.getElementById('hidden').style.display = 'block';
    }
  }

  onPasswordChange(event) {
    this.hashedPassword = "";
    this.password = event.target.value;
    let path = event.path;
    if (!event.path) {
      path = event.composedPath();
    }
    $("#" + path[2].id + " :input").attr("data-title", event.target.value);
    $("#" + path[2].id + " :input").attr("data-placeholder", event.target.value);
    $("#" + path[2].id + " :input").attr("value", event.target.value);
    this.passwordHistory = false;
    this.isPasswordChanged = true;
    this.enableUpdateButton();
  }

  onPasswordCheckboxChange(event) {
    if(this.highlightedElementId && this.highlightedElementId.includes("emptyfield")) {
      this.isFormvalid = false;
      return;
    }
    if (event.target.checked) {
      this.passwordEnabled = true;
      let passwordField = document.getElementById("password");
      $(passwordField).show();
      passwordField.children[1]["value"] = "";
      passwordField.children[1]["placeholder"] = "";
      $("#passwordShow").attr("disabled", false);
      let showPwd = $(".showPassword")[0];
      showPwd.children[0].style["pointerEvents"] = "";
      showPwd.children[1].style["pointerEvents"] = "";
      showPwd.children[0].style["cursor"] = "";
      showPwd.children[1].style["cursor"] = "";
    } else {
      this.passwordEnabled = false;
      let passwordField = document.getElementById("password");
      this.password = "";
      this.hashedPassword = ""
      $(passwordField).hide();
    }
    this.enableUpdateButton();
  }

  makeContentEditable(event) {
    let path = event.path;
    if (!event.path) {
      path = event.composedPath();
    }
    let inputId = path[2].id;
    let contentEditable = $(path[0]).attr("contentEditable");
    if (contentEditable !== "true") {
      $(path[0]).attr("contentEditable", "true");
      let element = $(path[0])[0];
      let length = element["innerText"].length;
      var textNode = element.firstChild;
      var caret = length;
      var range = document.createRange();
      range.setStart(textNode, caret);
      range.setEnd(textNode, caret);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }
    // Binding user input
    $(path[0]).bind("input", (element) => {
      if(element.target.outerText.length > 50) {
        let text = $("#" + inputId + " :input").attr("data-title");
        element.target.innerText = text;
        element.preventDefault();
        element.stopPropagation();
        return false;
      }
      $("#" + inputId + " :input").attr("data-title", element.target.outerText);
      $("#" + inputId + " :input").attr("data-label", element.target.outerText); // Remove it form render error persists
      $("#" + inputId + " :input").attr("data-placeholder", element.target.outerText);
      this.enableUpdateButton();
    });

    $(path[0]).bind("keydown", (element) => {
      if(element.keyCode === 13) {
        element.preventDefault();
        element.stopPropagation();
        return false;
      }
    });

    $(path[0]).bind("paste", (element) => {
      // access the clipboard using the api
      var labelTitle = element.target.innerText;
      var pastedData = element.originalEvent.clipboardData.getData('text');
      if (labelTitle.length > 50) {
        alert("Title cannot be more than 50 characters");
        element.preventDefault();
        element.stopImmediatePropagation();
        return false;
      }
      if (pastedData.length > 50) {
        alert("Title cannot be more than 50 characters");
        element.preventDefault();
        element.stopImmediatePropagation();
        return false;
      }
      $("#" + inputId + " :input").attr("data-title", pastedData);
      $("#" + inputId + " :input").attr("data-label", pastedData); // Remove it form render error persists
      $("#" + inputId + " :input").attr("data-placeholder", pastedData);
      this.enableUpdateButton();
    });
  }

  makeTopicFieldTitleEditable(event) {
    let component = this;
    let path = event.path;
    if (!event.path) {
      path = event.composedPath();
    }
    let inputId = path[1].id;
    let contentEditable = $(path[0]).attr("contentEditable");
    if (contentEditable !== "true") {
      $(path[0]).attr("contentEditable", "true");
      let element = $(path[0])[0];
      let length = element["innerText"].length;
      var textNode = element.firstChild;
      var caret = length;
      var range = document.createRange();
      range.setStart(textNode, caret);
      range.setEnd(textNode, caret);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }
    // Binding user input
    $(path[0]).bind("input", (element) => {
      if (element.target.outerText.length > form_limits.topicTitle.maxLength) {
        let text = $("#" + inputId).find("input:first").attr("data-title");
        element.target.innerText = text;
        element.preventDefault();
        element.stopPropagation();
        return false;
      }
      $("#" + inputId).find("input:first").attr("data-title", element.target.outerText);
      $("#" + inputId).find("input:first").attr("data-label", element.target.outerText);
      $("#" + inputId).find("input:first").attr("data-placeholder", element.target.outerText);
      this.enableUpdateButton();
    });

    $(path[0]).bind("keydown", (element) => {

      if(element.keyCode === 13) {
        element.preventDefault();
        return false;
      }
      this.enableUpdateButton();
    });

    $(path[0]).bind("paste", (element) => {
      // access the clipboard using the api
      var labelTitle = element.target.innerText;
      var pastedData = element.originalEvent.clipboardData.getData('text');
      if (labelTitle.length > form_limits.topic.maxLength) {
        element.preventDefault();
        element.stopImmediatePropagation()
        alert(`Topic cannot be more than ${form_limits.topic.maxLength} characters`);
        // component.openValidationError("Topic cannot be more than 50 characters")
        return false;
      }
      if (labelTitle.length +pastedData.length > form_limits.topic.maxLength) {
        element.preventDefault();
        element.stopImmediatePropagation()
        alert(`Topic cannot be more than ${form_limits.topic.maxLength} characters`);
        // component.openValidationError("Topic cannot be more than 50 characters")
        return false;
      }
      $("#" + inputId).find("input:first").attr("data-title", element.target.outerText);
      $("#" + inputId).find("input:first").attr("data-label", element.target.outerText);
      $("#" + inputId).find("input:first").attr("data-placeholder", element.target.outerText);
      this.enableUpdateButton();
    });
  }

  makeTopicTitleEditable(event) {
    event.stopImmediatePropagation()

    this.topicTitle = event.target.value
    this.enableUpdateButton();
  }

  makeSubjectTitleEditable(event) {
    let path = event.path;
    if (!event.path) {
      path = event.composedPath();
    }
    let contentEditable = $(path[0]).attr("contentEditable");
    if (contentEditable !== "true") {
      $(path[0]).attr("contentEditable", "true");
      let element = $(path[0])[0];
      let length = element["innerText"].length;
      var textNode = element.firstChild;
      var caret = length;
      var range = document.createRange();
      range.setStart(textNode, caret);
      range.setEnd(textNode, caret);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }
    // Binding user input
    $(path[0]).bind("input", (element) => {
      if (element.target.outerText.length > form_limits.comments.maxLength) {
        let text = $("#subject").attr("data-title");
        element.target.innerText = text;
        element.preventDefault();
        element.stopPropagation();
        return false;
      }
      $("#subject").attr("data-title", element.target.outerText);
      $("#subject").attr("data-label", element.target.outerText); // Remove it form render error persists
      $("#subject").attr("data-placeholder", element.target.outerText);
      this.enableUpdateButton();
    });

    $(path[0]).bind("keydown", (element) => {
      if(element.keyCode === 13) {
        element.preventDefault();
        element.stopPropagation();
        return false;
      }
    });

    $(path[0]).bind("paste", (element) => {
      // access the clipboard using the api
      var labelTitle = element.target.innerText;
      var pastedData = element.originalEvent.clipboardData.getData('text');
      if (labelTitle.length > form_limits.comments.maxLength) {
        alert(`Title cannot be more than ${form_limits.comments.maxLength} characters`);
        element.preventDefault();
        return false;
      }
      if (pastedData.length > form_limits.comments.maxLength) {
        alert(`Title cannot be more than ${form_limits.comments.maxLength} characters`);
        element.preventDefault();
        return false;
      }
      $("#subject").attr("data-title", element.target.outerText);
      $("#subject").attr("data-label", element.target.outerText); // Remove it form render error persists
      $("#subject").attr("data-placeholder", element.target.outerText);
      this.enableUpdateButton();
    });
  }

  makeEmployeeNameFieldEditable(event) {
    let path = event.path
    if(!event.path) {
      path = event.composedPath()
    }

    let contentEditable = $(path[0]).attr("contentEditable");
    if (contentEditable !== "true") {
      $(path[0]).attr("contentEditable", "true");
      let element = $(path[0])[0];
      let length = element["innerText"].length;
      var textNode = element.firstChild;
      var caret = length;
      var range = document.createRange();
      range.setStart(textNode, caret);
      range.setEnd(textNode, caret);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }
    // Binding user input
    $(path[0]).bind("input", (element) => {
      if (element.target.outerText.length > form_limits.name.maxLength) {
        let text = $("#employeeName").attr("data-title");
        element.target.innerText = text;
        element.preventDefault();
        element.stopPropagation();
        return false;
      }
      $("#employeeName").attr("data-title", element.target.outerText);
      $("#employeeName").attr("data-label", element.target.outerText); // Remove it form render error persists
      $("#employeeNameemployeeName").attr("data-placeholder", element.target.outerText);
      this.enableUpdateButton();
    });

    $(path[0]).bind("keydown", (element) => {
      if(element.keyCode === 13) {
        element.preventDefault();
        element.stopPropagation();
        return false;
      }
    });

    $(path[0]).bind("paste", (element) => {
      // access the clipboard using the api
      var labelTitle = element.target.innerText;
      var pastedData = element.originalEvent.clipboardData.getData('text');
      if (labelTitle.length > form_limits.name.maxLength) {
        alert(`Title cannot be more than ${form_limits.name.maxLength} characters`);
        element.preventDefault();
        return false;
      }
      if (pastedData.length > form_limits.name.maxLength) {
        alert(`Title cannot be more than ${form_limits.name.maxLength} characters`);
        element.preventDefault();
        return false;
      }
      $("#employeeName").attr("data-title", element.target.outerText);
      $("#employeeName").attr("data-label", element.target.outerText); // Remove it form render error persists
      $("#employeeName").attr("data-placeholder", element.target.outerText);
      this.enableUpdateButton();
    });
  }

  editSubtopicField(event) {
    let component = this;
    let path = event.path;
    if (!event.path) {
      path = event.composedPath();
    }
    let inputId = path[1].id;
    let contentEditable = $(path[0]).attr("contentEditable");
    if (contentEditable !== "true") {
      $(path[0]).attr("contentEditable", "true");
      let element = $(path[0])[0];
      let length = element["innerText"].length;
      var textNode = element.firstChild;
      var caret = length;
      var range = document.createRange();
      range.setStart(textNode, caret);
      range.setEnd(textNode, caret);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }
    $(path[0]).bind("input", (element) => {
      if (element.target.outerText.length > form_limits.subtopic.maxLength) {
        let text = $("#" + inputId + " :input").attr("data-title");
        element.target.innerText = text;
        element.preventDefault();
        element.stopPropagation();
        return false;
      }
      $("#" + inputId + " :input").attr("data-title", element.target.outerText);
      $("#" + inputId + " :input").attr("data-label", element.target.outerText);
      $("#" + inputId + " :input").attr("data-placeholder", element.target.outerText);
      this.enableUpdateButton();
    });

    $(path[0]).bind("keydown", (element) => {
      if(element.keyCode === 13) {
        element.preventDefault();
        return false;
      }
    });

    $(path[0]).bind("paste", (element) => {
      // access the clipboard using the api
      var labelTitle = element.target.innerText;
      var pastedData = element.originalEvent.clipboardData.getData('text');
      if (labelTitle.length > form_limits.subtopic.maxLength) {
        element.preventDefault();
        element.stopImmediatePropagation()
        alert(`Subtopic cannot be more than ${form_limits.subtopic.maxLength} characters`);
        // component.openValidationError("Subtopic cannot be more than 50 characters");
        return false;
      }
      if (labelTitle.length  +pastedData.length > form_limits.subtopic.maxLength) {
        element.preventDefault();
        element.stopImmediatePropagation()
        alert(`Subtopic cannot be more than ${form_limits.subtopic.maxLength} characters`);
        // component.openValidationError("Subtopic cannot be more than 50 characters");
        return false;
      }
      $("#" + inputId + " :input").attr("data-title", element.target.outerText);
      $("#" + inputId + " :input").attr("data-label", element.target.outerText);
      $("#" + inputId + " :input").attr("data-placeholder", element.target.outerText);
      this.enableUpdateButton();
    });
  }
  getHostName() {
    return document.location.protocol + '//' + window.location.host + '/';
  }

  openSnackBar(message) {
    this._snackBar.open(message, "Ok", {
      duration: 2000,
      panelClass: "my-custom-snackbar"
    });
  }

  openAddNewItem() {
    this.elements.push("");
    this.enableUpdateButton();
  }

  updateTopic() {
		let topic = {
			_id: this.topicsList[this.topicIndex]['_id'],
			name: this.topicsList[this.topicIndex].name,
			sub_topics: this.topicsList[this.topicIndex].sub_topics.length > 0 ? this.topicsList[this.topicIndex].sub_topics.filter(function (e) { return e }) : [],
			emails: this.topicsList[this.topicIndex].emails.length > 0 ? this.topicsList[this.topicIndex].emails.filter(function (e) { return e }) : [],
			sms: this.topicsList[this.topicIndex].sms.length > 0 ? this.topicsList[this.topicIndex].sms.filter(function (e) { return e }) : []
		}
		this._sortTopicsService.updateTopic(topic).subscribe((response) => {
			if (response['success']) {
				// this.dialogRef.close();
			}
		});
    this.enableUpdateButton();
	}

  removeOption(element, index) {
    this.elements.splice(index, 1);
    this.enableUpdateButton();
  }

  fieldPropertiesInputChange(value, index) {
    if (this.settingsTitle === "Sub Topics") {
      this.topicsList[this.topicIndex]["sub_topics"][index] = value;
    } else if (this.settingsTitle === "cc-SMS") {
      this.topicsList[this.topicIndex]["sms"][index] = value;
    } else {
      this.topicsList[this.topicIndex]["emails"][index] = value;
    }
    this.enableUpdateButton();
  }



  previewTemplate() {
    let url = this.getHostName() + "form-preview?id=" + this.templateId + "&preview=true";
    window.open(url, '_blank');
  }

  addNewTopicField() {
    if(this.highlightedElementId && this.highlightedElementId.includes("emptyfield")) {
      this.isFormvalid = false;
      return;
    }
    this.isTemplateChanged = true;
      let topicField = this.getNodes(this._formBuilderService.getNewTopicField("Topic")["template"]);
      let topicId = topicField[0]["id"];
      $("#madatory-fields").append(topicField);

      // Code to select the text of subtopic on creating new one
      let newTopicField = "#" + topicId
      let newTopicLabel= $(newTopicField).find("label[for =formName]")
      $(newTopicLabel).attr("contentEditable", "true");
      let element = newTopicLabel[0];
      let length = newTopicLabel.text().length
      var textNode = element.firstChild;
      var caret = length;
      var range = document.createRange();
      range.setStart(textNode, 0);
      range.setEnd(textNode, caret);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);

      this.enableUpdateButton();

        // Binding user input
    $(element).bind("input", (element) => {
      if (element.target.outerText.length > form_limits.topic.maxLength) {
        let text = $(newTopicField).find("input:first").attr("data-title");
        element.preventDefault();
        element.stopPropagation();
        element.target.innerText = text;
        return false;
      }
      $(newTopicField).find("input:first").attr("data-title", element.target.outerText);
      $(newTopicField).find("input:first").attr("data-label", element.target.outerText);
      $(newTopicField).find("input:first").attr("data-placeholder", element.target.outerText);
      this.enableUpdateButton();
    });

    $(element).bind("keydown", (element) => {

      if(element.keyCode === 13) {
        element.preventDefault();
        return false;
      }
      this.enableUpdateButton();
    });

    $(element).bind("paste", (element) => {
      // access the clipboard using the api
      var labelTitle = element.target.innerText;
      var pastedData = element.originalEvent.clipboardData.getData('text');
      if (labelTitle.length > form_limits.topic.maxLength) {
        element.preventDefault();
        element.stopImmediatePropagation();
        alert(`Topic cannot be more than ${form_limits.topic.maxLength} characters`);
        return false;
      }
      if (pastedData.length > form_limits.topic.maxLength) {
        alert(`Topic cannot be more than ${form_limits.topic.maxLength} characters`);
        element.preventDefault();
        element.stopImmediatePropagation();
        return false;
      }
      $(newTopicField).find("input:first").attr("data-title", element.target.outerText);
      $(newTopicField).find("input:first").attr("data-label", element.target.outerText);
      $(newTopicField).find("input:first").attr("data-placeholder", element.target.outerText);
      this.enableUpdateButton();
    });
      
        // if (result["subtopics"] && result["subtopics"].length > 0) {
        //   let subTopicField = this.getNodes(this._formBuilderService.getNewSubtopicField(topicId, result["subtopics"]).template);
        //   $("#"+topicId).append(subTopicField);
        // }
      // }
    // });
  }

  addNewSubtopicField(event) {
    
    if(this.highlightedElementId && this.highlightedElementId.includes("emptyfield")) {
      this.isFormvalid = false;
      return;
    }

    this.isTemplateChanged = true
    let path;
    if (event.path) {
      path = event.path;
    } else {
      path = event.composedPath();
    }
    let subTopicField = this.getNodes(this._formBuilderService.getNewSubtopicField(path[3]["id"], []).template);
    let topicId = path[3]["id"];
    let subtopicId = "#" + subTopicField[0]['id']
    $("#"+topicId).append(subTopicField);

    // Code to select the text of subtopic on creating new one
    let newSubtopicLabel= $(subtopicId).find("label[for =formName]")
    $(newSubtopicLabel).attr("contentEditable", "true");
    let element = newSubtopicLabel[0];
    let length = newSubtopicLabel.text().length
    var textNode = element.firstChild;
    var caret = length;
    var range = document.createRange();
    range.setStart(textNode, 0);
    range.setEnd(textNode, caret);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    
    this.enableUpdateButton();

    $(element).bind("input", (element) => {
      if (element.target.outerText.length > form_limits.subtopic.maxLength) {
        let text = $(subtopicId + " :input").attr("data-title");
        element.preventDefault();
        element.stopPropagation();
        element.target.innerText = text;
        return false;
      }
      $(subtopicId + " :input").attr("data-title", element.target.outerText);
      $(subtopicId + " :input").attr("data-label", element.target.outerText);
      $(subtopicId + " :input").attr("data-placeholder", element.target.outerText);
      this.enableUpdateButton();
    });

    $(element).bind("keydown", (element) => {
      if(element.keyCode === 13) {
        element.preventDefault();
        return false;
      }
    });

    $(element).bind("paste", (element) => {
      // access the clipboard using the api
      var labelTitle = element.target.innerText;
      var pastedData = element.originalEvent.clipboardData.getData('text');
      if (labelTitle.length > form_limits.subtopic.maxLength) {
        element.preventDefault();
        element.stopImmediatePropagation();
        alert(`Subtopic cannot be more than ${form_limits.subtopic.maxLength} characters`);
        return false;
      }
      if (pastedData.length > form_limits.subtopic.maxLength) {
        element.preventDefault();
        element.stopImmediatePropagation();
        alert(`Subtopic cannot be more than ${form_limits.subtopic.maxLength} characters`);
        return false;
      }
      $(subtopicId + " :input").attr("data-title", element.target.outerText);
      $(subtopicId + " :input").attr("data-label", element.target.outerText);
      $(subtopicId + " :input").attr("data-placeholder", element.target.outerText);
    });
  }

  enableUpdateButton(formName?) {
    this.isFormvalid = true;

    // Updating the schema for formPreview
    this.isForTelmplatePreview = true
    let newTemplate = {}
    newTemplate = this.createSchemaFromHtml()
    if(newTemplate) {
      this.topics = newTemplate['schema'][1]
      newTemplate['formName'] = this.templateName
      newTemplate['templateId'] = this.templateId
      if(formName) {
        newTemplate['formName'] = formName
      }
      if(!this.compareSchemas(this.template, newTemplate)){
        newTemplate['template_version'] = this.templateVersion
      } else {
        this.isTemplateChanged = true
        newTemplate['template_version'] = this.templateVersion
        newTemplate['isTemplateChanged'] = true
      }
      this._sharedService.changeTemplate(newTemplate);
    }
  }

  onReadTextCheckboxChange(event) {
    if(this.highlightedElementId && this.highlightedElementId.includes("emptyfield")) {
      event.preventDefault();
      event.stopPropagation();
      this.isFormvalid = false;
      return;
    }
    let path = event.path
    if (!event.path) {
      path = event.composedPath();
    }
    if(event.target.checked) {
      this.readTextFieldCheckbox = true
      $("#" + path[3].id + " :input").attr("data-visible", true);
    } else {
      this.readTextFieldCheckbox = false;
      $("#" + path[3].id + " :input").attr("data-visible", false);
    }
    this.enableUpdateButton();
  }

  onReadTextFieldChange(event) {
    let path = event.path
    if (!event.path) {
      path = event.composedPath();
    }

    $("#" + path[1].id + " :input").attr("data-title", event.target.value);
    $("#" + path[1].id + " :input").attr("data-placeholder", event.target.value);
    $("#" + path[1].id + " :input").attr("value", event.target.value);
    
    this.enableUpdateButton();
  }

  makeElementHighLight(event) {
    if (!this._sharedService.checkOpenMaterialDialogs()) {
      let elementId = event.currentTarget.id
      if(!elementId || !document.getElementById(elementId)) {
        return;
      }

      if(this.highlightedElementId == elementId) {
        return;
      }

      if(this.highlightedElementId != undefined) {
        if(this.highlightedElementId && this.highlightedElementId.includes("emptyfield") ) {
          this.openValidationError({
            message:"Please select a new item.",
          });
          this.isFormvalid = false;
          return;
        }
        if (document.getElementById(this.highlightedElementId)) {
          document.getElementById(this.highlightedElementId).classList.remove('highlight-element')
        }
      }
      let mainDiv = document.getElementById(elementId)
      this.highlightedElementId = elementId
      if(mainDiv) {
        mainDiv.classList.add('highlight-element')
      }
      if((event.target.id && event.target.id.includes("menubutton") == false) || !event.target.id) {
        this.closeMenu()
      }
    }
  }

  closeMenu() {
    if(this.openedElemntsMenuId != undefined) {
      if (document.getElementById(this.openedElemntsMenuId)) {
        document.getElementById(this.openedElemntsMenuId).style.display = "none"
      }
    }
    this.openedElemntsMenuId = undefined;
  }

  onMenuButtonClicked(event, from?) {    
    let path = event.path;
    if (!event.path) {
      path = event.composedPath();
    }

    // Checking if the new empty element is already selected but no type is selected
    if(path[2] && path[2].id && !path[2].id.includes("empty")) {
      if(this.highlightedElementId != undefined) {
        if(this.highlightedElementId && this.highlightedElementId.includes("emptyfield") ) {
          this.openValidationError({
            message:"Please select a new item.",
          });
          this.isFormvalid = false;
          return;
        }
        if (document.getElementById(this.highlightedElementId)) {
          document.getElementById(this.highlightedElementId).classList.remove('highlight-element')
        }
      }
    }
    
    let optionsDiv = path[1] && path[1].children[1] && path[1].children[1].id ? path[1].children[1].id : undefined
    if(this.openedElemntsMenuId != undefined) {
      if(document.getElementById(this.openedElemntsMenuId)) {
        document.getElementById(this.openedElemntsMenuId).style.display = "none"
      }
    }
    if(optionsDiv != undefined) {
      this.openedElemntsMenuId = optionsDiv;
      document.getElementById(optionsDiv).style.display = "block"
    }
  }

  onFormElementTypeChanged(event, type) {

    let path = event.path
    if (!event.path) {
      path = event.composedPath();
    }
    let presentElement = path[3].id
    let newElementId;
    switch (type) {
      case "text":
        newElementId = this.addNewItemToFormComponent.addSingleLineText(presentElement)
        break;
      case "textarea":
        newElementId = this.addNewItemToFormComponent.addMultiLineText(presentElement)
        break;
      case "email":
        newElementId = this.addNewItemToFormComponent.addEmailField(presentElement)
        break;
      case "phone":
        newElementId = this.addNewItemToFormComponent.addPhoneField(presentElement)
        break;
      case "radio":
        newElementId = this.addNewItemToFormComponent.addOptionsButton(presentElement)
        break;
      case "checkbox":
        newElementId = this.addNewItemToFormComponent.addCheckBoxButton(presentElement)
        break;
      case "select":
        newElementId = this.addNewItemToFormComponent.addDropDownBox(presentElement)
        break;
      case "picture":
        newElementId = this.addNewItemToFormComponent.addPictureUpload(presentElement)
        break;
      case "file":
        newElementId = this.addNewItemToFormComponent.addFileUpload(presentElement)
        break;
      case "question":
        newElementId = this.addNewItemToFormComponent.addQuestion(presentElement)
        break;
      case "contact":
        newElementId = this.addNewItemToFormComponent.addContact(presentElement)
        break;
      case "address":
        newElementId = this.addNewItemToFormComponent.addAddress(presentElement)
        break;
      case "date":
        newElementId = this.addNewItemToFormComponent.addDate(presentElement)
        break;
      case "time":
        newElementId = this.addNewItemToFormComponent.addTime(presentElement)
        break;
      
      default:
        break;
    }
    this.enableUpdateButton()
    this.makeElementHighlightById(newElementId)
  }

  onRequiredFieldCheckBoxChange(event) {
    if(this.highlightedElementId && this.highlightedElementId.includes("emptyfield")) {
      this.isFormvalid = false;
      return;
    }
    let path = event.path
    if (!event.path) {
      path = event.composedPath();
    }
    if(event.target.checked == true) {
      $("#" + path[3].id + " :input").attr("data-required", true);
    } else {
      $("#" + path[3].id + " :input").attr("data-required", false);
    }
    this.enableUpdateButton()
  }

  _onOptionsChanged(event, index, type, key) {
    let path = event.path
    if (!event.path) {
      path = event.composedPath();
    }
    let options = []
    // Getting already having options
    if(type == "label") {
      $("#" + path[3].id + " :input").attr("data-options", function(node, value) {
        if(value != undefined) {
          try {
          options = JSON.parse(value)
        } catch (e) {
          console.error(e)
          return;
        }
        }
      });
    } else {
      $("#" + path[5].id + " :input").attr("data-options", function(node, value) {
        if(value != undefined) {
         try {
          options = JSON.parse(value)
        } catch (e) {
          console.error(e)
          return;
        }
        }
      });
    }
    // Finding the index of the option to be editied
    let optionIndex = options.findIndex(option => option.key == key)
    if(type == "label") {
      options[optionIndex]['label'] = event.target.value
      options[optionIndex]['value'] = event.target.value.toLowerCase()
    } else {
      options[optionIndex]['visible'] = event.target.checked
    }
    // Updating thhh changed options
    type == "label" ? $("#" + path[3].id + " :input").attr("data-options", JSON.stringify(options)) : $("#" + path[5].id + " :input").attr("data-options", JSON.stringify(options));
    this.enableUpdateButton()
  }

  onOptionsChanged(event, index, type, key) {

    const eventData = {
      target: event.target,
      path: event.path || event.composedPath()
    };

    this.debouncedOnOptionsChanged(eventData, index, type, key);
  }



  onDeletingOptions(event, index, key) {
    let path = event.path
    if (!event.path) {
      path = event.composedPath();
    }
    let options = []
    $("#" + path[3].id + " :input").attr("data-options", function (node, value) {
      if (value != undefined) {
        try {
          options = JSON.parse(value)
        } catch (e) {
          console.error(e)
          return;
        }
        
      }
    });
    // Removing option from array
    let optionIndex = options.findIndex(option => option.key === key)
    options.splice(optionIndex, 1)

    // Removing thhe html element from DOM
    let optionToDelete = document.getElementById(path[1].id)
    optionToDelete.remove()

    // Updating options in data-options attribute
    $("#" + path[3].id + " :input").attr("data-options", JSON.stringify(options))
    this.enableUpdateButton()
  }

  onAddOption(event) {
    if(this.highlightedElementId && this.highlightedElementId.includes("emptyfield")) {
      this.isFormvalid = false;
      return;
    }
    let path = event.path
    if (!event.path) {
      path = event.composedPath();
    }
    let options = []
    // Getting existed data-options
    $("#" + path[1].id + " :input").attr("data-options", function (node, value) {
      if (value != undefined) {
        try {
          options = JSON.parse(value)
        } catch (e) {
          console.error(e)
          return;
        }
      }
    });
    let newOption = {
      label: `Option ${options.length + 1}`,
      visible: true,
      value: `Option ${options.length + 1}`,
      key: this._formBuilderService.generateRandomString()
    }
    options.push(newOption)
    let newOptionDom = this.getNewOptionDomElement(newOption, options.length - 1)
    // Adding dom element option the field
    $("#" + path[1].id).children('div').eq(3).append(newOptionDom)
    // Updating options for the fields data-options
    $("#" + path[1].id + " :input").attr("data-options", JSON.stringify(options))
    this.enableUpdateButton()
  }

  getNewOptionDomElement(option, index) {
    let template = this._formBuilderService.getOptionForField(option, index)
    return new DOMParser().parseFromString( template, "text/html").body.childNodes;
  }

  openFieldInfoPopup(event, type) {
    let path = event.path
    let data = {}
    if(!event.path) {
      path = event.composedPath();
    }
    if(type == 'topic') {
      const topicId = path[3].id
      const inputElement = document.getElementById(topicId).children[2]
      data['content'] = inputElement.getAttribute('data-label')
      data['type'] = "topic"

    } else if(type == 'subtopic') {
      const topicId = path[2].id
      const inputElement = document.getElementById(topicId).children[2]
      data['content'] = inputElement.getAttribute('data-label')
      data['type'] = "subtopic"
    }
    const dialogRef = this.dialog.open(ElementInfoPopupComponent, {
      width: '500px',
      data,
      disableClose: true
    });
  }

  // On hovering the input elment making more grey
  onFocusInputField(event) {
    event.target.style.background = '#dfdfdf';
  }

  onFocusOutInputField(event) {
    event.target.style.background = '';
  }

  onElementLabelChange(event) {
    event.preventDefault()
    event.stopImmediatePropagation()
    let path = event.path
    if (!event.path) {
      path = event.composedPath();
    }

    $(path[0]).attr("data-title", event.target.value);
    $(path[0]).attr("data-label", event.target.value);
    $(path[0]).attr("data-placeholder", event.target.value);
    $(path[0]).attr("value", event.target.value);

    this.enableUpdateButton();

  }

  disableUpdateButton() {
    this.isForTelmplatePreview = false;
    this.createSchemaFromHtml()
  }

  makeElementHighlightById(elementId) {
    if(this.highlightedElementId) {
      let mainDiv = document.getElementById(this.highlightedElementId)
      if(mainDiv) {
        mainDiv.classList.remove('highlight-element');
      }
    }
    if(elementId) {
      this.highlightedElementId = elementId;
      let mainDiv = document.getElementById(elementId)
      if(mainDiv) {
        mainDiv.classList.add('highlight-element')
      }
    }
  }

  onFocusElementMoved(event) {
    this.isForTelmplatePreview = false
    this.updateForm("DRAFT")
  }

    onSaveElementMoved(event) {
    this.isForTelmplatePreview = false
    this.enableUpdateButton();
    this.updateForm("DRAFT")
  }

  onTabSwitch(event) {
    if(document.visibilityState && document.visibilityState == "hidden") {
      if(!Window['app']._sharedService.checkOpenMaterialDialogs()) {
        if(Window['app'].isTemplateChanged == true && Window['app'].isFormvalid == true) {
          Window['app'].updateForm("SAVE")
          Window['app'].saveValidityCheck = true
          Window['app'].isTemplateChanged = false
        }
      }
    }
  }
  isHavingDuplicates(array, type): any {
    if(array && array.length > 0) {
      for(let topic of array) {
        if(this.findEmptyTopics(array)) {
          this.openValidationError(`Please enter Topic value`)
          return  true;
        }
        let dupTopic = this.findDuplicateTopic(array);
        if(dupTopic != false) {
          this.openValidationError(`${dupTopic} is already exist, please enter different topic name or add subtopics under existing topic`)
          return true;
        }
        
        if(topic && topic['options'] && topic['options'].length > 0) {
          if(this.findEmptyTopics(topic['options'])) {
            this.openValidationError(`Please enter Sub-Topic value`)
            return true;
          }
          let dupSubtopic = this.findDuplicateTopic(topic['options'])
          if(dupSubtopic != false) {
            this.openValidationError(`${dupSubtopic} is already exist, please enter different subtopic name.`)
            return true;
          }
        }
      } 
    }
  }

  onFocusOutTopicsSubTopics(type?) {
    if(this.isHavingDuplicates(this.topics?this.topics['data'] : [], 'topic')){
      this.isFormvalid = false;
      return true;
    } 
  }

  findEmptyTopics(arr): any {
    for(let element of arr) {
      if(element && element['label'].length == 0) {
        return true;
      }
    }
    return false;
  }
  
  findDuplicateTopic(arr) {
    let tempHash = {};
    for(let element of arr) {
      if(element && element['label'] in tempHash) {
        return element['label'];
      }
      tempHash[`${element['label']}`] = element['label'];
    }
    return false;
  }

  fieldConfig = {
    formName: { label: "Form Title", maxLength: form_limits.formTitle.maxLength },
    description: { label: "Form Description", maxLength: form_limits.formDescription.maxLength },
    topicTitle: { label: "Topic Title", maxLength: form_limits.topic.maxLength },
    employeeName: { label: "Name", maxLength: form_limits.name.maxLength },
    comments: { label: "Comments title", maxLength: form_limits.comments.maxLength },
    phone: { label: "Phone number title", maxLength: form_limits.phone.maxLength },
    email: { label: "Email address title", maxLength: form_limits.email.maxLength },
    dropdown: { label: "Dropdown title", maxLength: form_limits.dropdown.maxLength },
    pictureUpload: { label: "Picture Upload title", maxLength: form_limits.pictureUpload.maxLength },
    fileUpload: { label: "File Upload title", maxLength: form_limits.fileUpload.maxLength },
    address: { label: "Address title", maxLength: form_limits.address.maxLength },
    radio: { label: "Radio button title", maxLength: form_limits.options.maxLength },
    checkbox: { label: "Checkbox title", maxLength: form_limits.options.maxLength },
    date: { label: "Date title", maxLength: form_limits.date.maxLength },
    time: { label: "Time title", maxLength: form_limits.time.maxLength },
    text: { label: "Text box title", maxLength: form_limits.textBox.maxLength },
    question: { label: "Yes/No button question title", maxLength: form_limits.yesNoButtons.maxLength },
    contact: { label: "Request to be contacted title", maxLength: form_limits.requestToBeContacted.maxLength},
    topic: { label: "Topic", maxLength: form_limits.topic.maxLength },
    subtopic: { label: "Subtopic", maxLength: form_limits.subtopic.maxLength },
  };

  onPastingContent(type, event, fieldType) {
    console.log("Pasting content event", type, event, fieldType);
    if (type === "element") {
      const config = this.fieldConfig[fieldType] || { label: "Element Title", maxLength: 300 };
      const maxLength = config.maxLength;
      const fieldValue = event.target.value || "";
      const pastedData = event.clipboardData.getData("text/plain") || "";
      const totalLength = fieldValue.length + pastedData.length;

      if (totalLength > maxLength) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const alertContent =
          `${config.label}` +
          ` cannot be more than ${maxLength} characters`;

        alert(alertContent.charAt(0).toUpperCase() + alertContent.slice(1));
        return false;
      }
    } else if (type === "option") {
      const fieldValue = event.target.value || "";
      const pastedData = event.clipboardData.getData("text/plain") || "";
      const totalLength = fieldValue.length + pastedData.length;

      if (totalLength > form_limits.options.maxLength) {
        event.preventDefault();
        event.stopImmediatePropagation();
        alert(`Options cannot be more than ${form_limits.options.maxLength} characters`);
        return false;
      }
    }
  } 


  // onPastingContent(type, event, fieldType ?) {
  //   let component = this;
  //   if (type === "element") {
  //     const fieldValue = event.target.value;
  //     let pastedData;
  //     let clipboardData = event.clipboardData;
  //     pastedData = clipboardData.getData('text/plain');
  //     let alertContent = "";
  //     switch (fieldType) {
  //       case "formName":
  //         alertContent = `Form Title cannot be more than 300 characters`;
  //         break;
  //       case "topicTitle":
  //         alertContent = `Topic Title cannot be more than 300 characters`;
  //         break;
  //       case "employeeName":
  //         alertContent = `Employee name title cannot be more than 300 characters`;
  //         break;
  //       case "description":
  //         alertContent = `Form description cannot be more than 300 characters`;
  //         break;
  //       case "comments":
  //         alertContent = `Comments title cannot be more than 300 characters`;
  //         break;
  //       default:
  //         alertContent = `Element Title cannot be more than 300 characters`;
  //     }
  //     if ((fieldValue + pastedData).length > 300) {
  //       event.preventDefault()
  //       event.stopImmediatePropagation()
  //       // component.openValidationError("Title cannot be more than 300 characters")
  //       alert(alertContent)
  //       return false;
  //     }
  //   } else if (type === "option") {
  //     const fieldValue = event.target.value;
  //     let pastedData;
  //     let clipboardData = event.clipboardData;
  //     pastedData = clipboardData.getData('text/plain');
  //     if ((fieldValue + pastedData).length > 300) {
  //       event.preventDefault()
  //       event.stopImmediatePropagation()
  //       // component.openValidationError("Title cannot be more than 300 characters")
  //       alert("Options cannot be more than 50 characters")
  //       return false;
  //     }
  //   }
  // }

  onFocusRemoveReadonly(event: any) {
    if(event && event.target) {
      event.target.removeAttribute("readonly");
    }
  }
}
